import BaseComponent from '../abstracts/BaseComponent';

export default class StateSelectorComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.COUNTRY_SELECTOR_EVENTS.change]: this.changeInput
    };
  }

  get CLASSES() {
    return {
      showSelect: 'show-state-select'
    };
  }

  get SELECTOR() {
    return {
      input: 'input',
      select: 'select'
    };
  }

  get BASE_CONF() {
    return {
      htmlName: this.$options.htmlname,
      id: 'stateCode',
      // PDB-763
      // selectCountryCode: 'IT',
      countriesStates: this.$options.countriesstates
    };
  }

  constructor(element) {
    super(element);
  }

  changeInput({ countryCode }) {
    const input = this.$el.querySelector(this.SELECTOR.input);
    const select = this.$el.querySelector(this.SELECTOR.select);
    input.value = '';
    select.value = '';
    const states = this.BASE_CONF.countriesStates[countryCode];
    if (states) {
      // mostare select
      input.setAttribute('name', 'stateInput');
      input.setAttribute('id', 'state');
      input.removeAttribute('required');
      select.setAttribute('name', this.BASE_CONF.htmlName);
      select.setAttribute('id', this.BASE_CONF.id);
      select.setAttribute('required', 'required');
      this.$el.classList.add(this.CLASSES.showSelect);
      // PDB-763
      select.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
      states.forEach(state => select.insertAdjacentHTML('beforeend', `<option id="${state.id}" value="${state.htmlValue}">${state.label || ' '}</option>`));
    } else {
      // mostare input
      select.setAttribute('name', 'stateSelect');
      select.setAttribute('id', 'state');
      select.removeAttribute('required');
      input.removeAttribute('required');
      input.setAttribute('id', this.BASE_CONF.id);
      input.setAttribute('name', this.BASE_CONF.htmlName);
      this.$el.classList.remove(this.CLASSES.showSelect);
    }
  }
}
